import $ from "jquery"
import "jquery-match-height";

$('.js-team-item-cta-more').each(function() {
    $(this).on('click', function() {
        $(this).closest('.team__item').addClass('team__item--active');
    });
});

$('.js-team-item-cta-less').each(function() {
    $(this).on('click', function() {
        $(this).closest('.team__item').removeClass('team__item--active');
    });
});

$('.js-team-item-info-height').matchHeight();